// extracted by mini-css-extract-plugin
export default {"content":"SectionHeader_content__YOchB","header":"SectionHeader_header__MyIzR","btn":"SectionHeader_btn__Ppzhf"};